import { render, staticRenderFns } from "./SettingsView.vue?vue&type=template&id=41be15b0&scoped=true"
import script from "./SettingsView.vue?vue&type=script&lang=js"
export * from "./SettingsView.vue?vue&type=script&lang=js"
import style0 from "./SettingsView.vue?vue&type=style&index=0&id=41be15b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41be15b0",
  null
  
)

export default component.exports